import { jsx as _jsx } from "react/jsx-runtime";
import { Fields } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import { Tooltip } from "@air/primitive-tooltip";
import { memo } from "react";
import { usePublicCustomFieldsPanel } from "~/components/PublicBoard/components/PublicBoardCustomFieldsPanelContent/hooks/usePublicCustomFieldsPanel";
export const PublicBoardHeaderActionsCustomFieldsButton = /*#__PURE__*/ memo(()=>{
    const { togglePanel } = usePublicCustomFieldsPanel();
    const label = "View custom fields";
    if (!togglePanel) return null;
    return /*#__PURE__*/ _jsx(Tooltip, {
        label: label,
        children: /*#__PURE__*/ _jsx(IconButton, {
            appearance: "ghost",
            color: "grey",
            "data-testid": "PUBLIC_CUSTOM_FIELDS_BUTTON",
            icon: Fields,
            label: label,
            onClick: togglePanel,
            size: "medium"
        })
    });
});
PublicBoardHeaderActionsCustomFieldsButton.displayName = "PublicBoardHeaderActionsCustomFieldsButton";
